__turbopack_context__.v({
  "gsap-animated": "TimelineClient-module__GfR9tq__gsap-animated",
  "is-visible": "TimelineClient-module__GfR9tq__is-visible",
  "mask": "TimelineClient-module__GfR9tq__mask",
  "pop": "TimelineClient-module__GfR9tq__pop",
  "showTimelineItem": "TimelineClient-module__GfR9tq__showTimelineItem",
  "timeline-container": "TimelineClient-module__GfR9tq__timeline-container",
  "timeline-content": "TimelineClient-module__GfR9tq__timeline-content",
  "timeline-description": "TimelineClient-module__GfR9tq__timeline-description",
  "timeline-dot": "TimelineClient-module__GfR9tq__timeline-dot",
  "timeline-item": "TimelineClient-module__GfR9tq__timeline-item",
  "timeline-line": "TimelineClient-module__GfR9tq__timeline-line",
  "timeline-step": "TimelineClient-module__GfR9tq__timeline-step",
  "timeline-title": "TimelineClient-module__GfR9tq__timeline-title",
});
